import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from "../c005-bookingform-common";
import * as numeral from 'numeral';
let GrabID = require('GrabID');

export class memberPointsExchange {
	private partnerPointsExcForm:any   = $('#points-exchange-admin-form');
	$instance:any;
	private bookingformcommon = new bookingFormCommon();
	private initialBal:any;
	private minEnrichPoints:any;
	private binfiniteExcList:any;
	private extRefList:any;
	private grabIdClient:any;
	private bonusExcList:any;
	private voucherList:any
	private mymilesPointExchange: any = $('#points-exchange-admin-form');
	private pointsExchangeData: any = null;
	private selectedDenomination: any;
	private selectedVoucher: any;
	private eligibilityFlag: any;
	private totalVoucherRedeemed: any;
	private countryDtls:any;
	private recipientID: any = null;
	private occasion: any='';
	private giftMessage: any = '';
	private memberToken: any;
	// private incrementDisplayValue:any = 0;

	initSelectCard(): any {
    let defer = $.Deferred();
		let _self = this;
		let enrichMilesInput = _self.partnerPointsExcForm.find('#enrich-miles-field');
		let bInfiniteInput = _self.partnerPointsExcForm.find('#b-infinity-field');
		let grab_enrichMilesInput = _self.partnerPointsExcForm.find('#grab-enrich-points-field');
		let grabInputpoints = _self.partnerPointsExcForm.find('#grab-points-field');
		//var queryString, a, value1, value2;
		let partner_code  = $(".points-exchange-form-display input:hidden[class='partnerId']").val();
		let ppgSMTLoginUrl= $(".points-exchange-form-display input:hidden[class='smtLoginUrl']").val();
		let smtRedirectPath=$(".points-exchange-form-display input:hidden[class='smtRedirectPath']").val();
		let value2=partner_code;
		
		_self.bookingformcommon.preloader();
		
		 
			//queryString = location.search.substring(1);
			//a = queryString.split("&");
			//value1 = a[0];
			//value2 = a[1];
			$('#'+value2).removeClass("hidden");
			$('#'+value2).removeClass("inactive");
			$('#'+value2).addClass("active");
			$('#' + value2 + "_tnc").removeClass("hidden");
            $('#' + value2 + "_tnc").removeClass("inactive");
            $('#' + value2 + "_tnc").addClass("active");
			$('#' + value2 + "_checkbox").removeClass("hidden");
            $('#' + value2 + "_checkbox").removeClass("inactive");
            $('#' + value2 + "_checkbox").addClass("active");
		
		$(".btn-member--cancel").click(function() {
			//let partner_code  = $(".points-exchange-form-display input:hidden[class='partnerId']").val();
			if(partner_code == 'Grab') {
				let url = location.href;
				url = url.split('?')[0];
				window.location.href = url+'Grab&Grab';
			} else {
				location.reload();
			}
		});
		let memTokenVal:any;
		let awardcode:any;
		let cartId=value2;
		let partner=_self.partnerPointsExcForm.find(cartId);
		let max_exc_points:any;
		let pointExcList:any;
		let succCode:any;
		let stepValue:any;
		let cookieAccessToken = _self.getCookie("sapphire");
		var decodedToken = parseJwt(cookieAccessToken);
		var data:any;
		if(partner_code=='ppgsmt'){
			$(".binfinte_acc").removeClass("showclass");
			$(".binfinte_acc").addClass("hideclass");
			$("#confirm--binfinte_acc").removeClass("showclass");
			$("#confirm--binfinte_acc").addClass("hideclass");
			if(_self.checkForUrlParams()){
				data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid,
					'partnerId': cartId,
					'memberToken':_self.memberToken
				};

			}else{
				window.location.href = ppgSMTLoginUrl+smtRedirectPath;
				_self.bookingformcommon.preloaderClose();
			}
		}
		else{
			data = {
				'loyaltyToken':	decodedToken.extension_loyaltyToken,
				'enrichId': decodedToken.extension_flyerid,
				'partnerId': cartId
			};
		}

		_self.bookingformcommon.preloader();
		$.ajax({
			type: 'POST',
			url: '/bin/services/new/onloadExcPontsDtls',
			data: data,
			success: function(data:any){
				//var json = JSON.parse(data);
				let json:any = null;
					if (typeof data === 'string') {
						json = JSON.parse(data);
					}	else {
						json = data;
					}
				_self.bookingformcommon.preloaderClose();
				_self.initialBal = json.currentBalance;
				max_exc_points=json.maxExchangePoints;
				pointExcList= json.promoCodeList;
				memTokenVal=json.memTokenVal;
				succCode=json.succCode;
				if (succCode == "OK") {					
					$(".disply-partner-cards").removeClass("showclass");
					$(".disply-partner-cards").addClass("hideclass");
					$(".points-exchange-form-display").removeClass("hideclass");//SHOW
					$(".points-exchange-form-display").addClass("showclass");//SHOW
					$( "h2" ).hide();
					let hiddenMemToken = _self.partnerPointsExcForm.find('#memTokenVal');
					hiddenMemToken.val(memTokenVal);
					_self.extRefList=json.extLinkRefList;
					if(_self.extRefList!=null && _self.extRefList.length>0) {
						for(let i=0;i<_self.extRefList.length;i++){
							if(_self.extRefList[i].subType!=null && _self.extRefList[i].subType!="" && _self.extRefList[i].subType!=undefined){
								$("#partner-card-number").val(_self.extRefList[i].identifier);
								$("#mob-partner-card-number").val(_self.extRefList[i].identifier);
							}
						}
					}
				_self.initialBal = json.currentBalance;
				_self.voucherList = json.promoCodeList;
				_self.selectedVoucher = _self.voucherList[0];
				_self.selectedDenomination = _self.selectedVoucher.exchangepoints;
				if(pointExcList.length>0) {
					for(let i=1;i<=pointExcList.length;i++) {
						_self.minEnrichPoints = pointExcList[i-1].EnrichMinPoints;
					}
				}
				
				if(parseInt(_self.initialBal)<parseInt(_self.minEnrichPoints)) {
					$(".error-validation").removeClass("hideclass");
					$(".error-validation").addClass("showclass");
					$(".rangeerrorBalCheck").removeClass("hideclass");
					$(".rangeerrorBalCheck").addClass("showclass");
					$(".btn-points-form--next").addClass("disablee");
				}
				console.log(_self.selectedVoucher.exchangepoints);
				_self.initDenominations();
				_self.bookingformcommon.preloaderClose();
				} else if(succCode == "MPE_ERROR") {
					$(".maxErrorMsg").removeClass("hideclass");
					$(".maxErrorMsg").addClass("showclass");
				}else if(succCode == "SMTNOK") {
					$(".disply-partner-cards").removeClass("showclass");
					$(".disply-partner-cards").addClass("hideclass");
					$(".points-exchange-form-display").removeClass("hideclass");//SHOW
					$(".points-exchange-form-display").addClass("showclass");//SHOW
					$( "h2" ).hide();
					$(".error-validation").removeClass("hideclass");
                   	$(".error-validation").addClass("showclass");
					$(".accounterror").removeClass("showclass");
					$(".accounterror").addClass("hideclass");
					$(".rangeerror").removeClass("showclass");
					$(".rangeerror").addClass("hideclass");
					$(".rangeerrorBalCheck").removeClass("showclass");
					$(".rangeerrorBalCheck").addClass("hideclass");
					$(".cardStatusError").removeClass("hideclass");
					$(".cardStatusError").addClass("showclass");
				}else{
					$(".points-exchange-form-display").removeClass("hideclass");//SHOW
					$(".points-exchange-form-display").addClass("showclass");//SHOW
					$( "h2" ).hide();
					$(".error-validation").removeClass("hideclass");
					$(".error-validation").addClass("showclass");
					$(".onloadErrorMsg").removeClass("hideclass");
					$(".onloadErrorMsg").addClass("showclass");
				}
				defer.resolve(json);			
			}, error: function(error: any) {
				_self.bookingformcommon.preloaderClose();
				defer.reject(error);
			}
		});
		function parseJwt (token:any): any {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(base64);
		};
	}
	getCookie(name:string): any {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		var cookieVal:any;
		if (parts.length == 2) {
			cookieVal = parts.pop().split(";").shift();
			return cookieVal;
		}
	}
	initSubmitNextForm(): any {
		let defer = $.Deferred();
		let _self = this;
		//Binfinite
		let enrichMilesConfirmPoints = _self.partnerPointsExcForm.find('#total-miles-deduct--confirm');
		let bInfiniteConfirmPoints = _self.partnerPointsExcForm.find('#total-binfinite-recieve--confirm');
		let cardConfirmNumber = _self.partnerPointsExcForm.find('#b-infinite-acct-number--confirm');
		$(".btn-points-form--next-admin").click(function() {
			let partner_code  = $(".points-exchange-form-display input:hidden[class='partnerId']").val();
			//Binfinite
			let enrichMilesInputPoints = _self.partnerPointsExcForm.find('#enrich-miles-field').val();
		  let bInfiniteInputPoints = _self.partnerPointsExcForm.find('#b-infinity-field').val();
			let cardInputNumber_deskT = _self.partnerPointsExcForm.find('#partner-card-number').val();
			let cardInputNumber_mob = _self.partnerPointsExcForm.find('#mob-partner-card-number').val();
			let cardInputNumber:any;
			let enrichMiles:any;
			let inputPoints:any;
			let cardNumberwithSpace:any;
			if(partner_code=='ppgsmt'){
				cardInputNumber="1111 1111 1111 1111"
			}
			else{
			if(cardInputNumber_mob!="") {	
					cardInputNumber=cardInputNumber_mob;
				} else {
					cardInputNumber=cardInputNumber_deskT;
				}
			}
				enrichMiles=enrichMilesInputPoints;
				inputPoints=bInfiniteInputPoints;
				cardNumberwithSpace=cardInputNumber;
				//alert("cardInputNumber>>"+cardNumberwithSpace);
				cardInputNumber=cardInputNumber.replace(/ /g,'');
			
			 if((partner_code != 'Grab') && (enrichMiles=="" || inputPoints=="" || cardInputNumber=="" || !($('#points-exc--miles-terms-and-conditions').prop('checked')))) {
			 	if(!($('#points-exc--miles-terms-and-conditions').prop('checked'))) {
			 		if(cardInputNumber=="") {
						$(".error-validation").removeClass("hideclass");
						$(".error-validation").addClass("showclass");
						$(".accounterror").removeClass("hideclass");
						$(".accounterror").addClass("showclass");
			 		} else {
						$(".accounterror").removeClass("showclass");
						$(".accounterror").addClass("hideclass");
						$(".error-validation").removeClass("showclass");
						$(".error-validation").addClass("hideclass");
			 		}
			 		if(enrichMiles=="" || inputPoints=="") {
			 			$(".error-validation").removeClass("hideclass");
                 	    $(".error-validation").addClass("showclass");
			 			$(".rangeerror").removeClass("hideclass");
			 			$(".rangeerror").addClass("showclass");
			 		} else {
			 			$(".rangeerror").removeClass("showclass");
			 			$(".rangeerror").addClass("hideclass");
			 			$(".error-validation").removeClass("showclass");
            $(".error-validation").addClass("hideclass");
			 		}
			 		$(".radioErrMsg").removeClass("hideclass");
			 		$(".radioErrMsg").addClass("showclass");
			 		$(".error-validation").removeClass("hideclass");
          $(".error-validation").addClass("showclass");
			 	} else {
			 		$(".radioErrMsg").removeClass("showclass");
			 		$(".radioErrMsg").addClass("hideclass");
			 		$(".error-validation").removeClass("showclass");
          $(".error-validation").addClass("hideclass");
			 		if(cardInputNumber=="") {
						if(enrichMiles==""|| inputPoints=="") {
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".rangeerror").removeClass("hideclass");
							$(".rangeerror").addClass("showclass");
						} else {
							$(".rangeerror").removeClass("showclass");
							$(".rangeerror").addClass("hideclass");
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
						}
						$(".error-validation").removeClass("hideclass");
						$(".error-validation").addClass("showclass");
						$(".accounterror").removeClass("hideclass");
						$(".accounterror").addClass("showclass");
			 		} else {
						$(".accounterror").removeClass("showclass");
						$(".accounterror").addClass("hideclass");
						$(".error-validation").removeClass("showclass");
						$(".error-validation").addClass("hideclass");
						if(enrichMiles==""|| inputPoints=="") {
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".rangeerror").removeClass("hideclass");
							$(".rangeerror").addClass("showclass");
						} else {
							$(".rangeerror").removeClass("showclass");
							$(".rangeerror").addClass("hideclass");
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
						}
			 		}
				}
			 } else if(partner_code !== 'Grab' && cardInputNumber.length!=16){
			 	if(cardInputNumber.length==16){
			 		$(".error-validation").removeClass("showclass");
			 		$(".error-validation").addClass("hideclass");
			 		$(".cardStatusError").removeClass("showclass");
			 		$(".cardStatusError").addClass("hideclass");
			 	} else {
			 		$(".error-validation").removeClass("hideclass");
			 		$(".error-validation").addClass("showclass");
			 		$(".cardStatusError").removeClass("hideclass");
			 		$(".cardStatusError").addClass("showclass");
			 	}
			 }
			else if((parseInt(_self.initialBal)<parseInt(_self.minEnrichPoints)) ||
			(parseInt(_self.initialBal)<parseInt(enrichMiles)))
			{
				$(".error-validation").removeClass("hideclass");
      			$(".error-validation").addClass("showclass");
				$(".rangeerrorBalCheck").removeClass("hideclass");
				$(".rangeerrorBalCheck").addClass("showclass");
			}
			else {
				$(".error-validation").removeClass("showclass");
				$(".error-validation").addClass("hideclass");
				$(".rangeerrorBalCheck").removeClass("showclass");
				$(".rangeerrorBalCheck").addClass("hideclass");
				let cardStatus:any;
				var data = {
					'cardNumber':	cardInputNumber,
					'partner_code':partner_code
				};
				_self.bookingformcommon.preloader();
				$.ajax({
					type: 'GET',
					url: '/bin/services/new/getBinfinitecardstatusLcp',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
							if (typeof data === 'string') {
								json = JSON.parse(data);
							}	else {
								json = data;
							}
						_self.bookingformcommon.preloaderClose();
						cardStatus=json.status;
						
						if (cardStatus == "Active") {
							//$("#termscondiText").removeClass("radioErrMsg");
							$(".radioErrMsg").removeClass("showclass");
                	        $(".radioErrMsg").addClass("hideclass");
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
							$(".accounterror").removeClass("showclass");
							$(".accounterror").addClass("hideclass");
							$(".rangeerror").removeClass("showclass");
							$(".rangeerror").addClass("hideclass");
							$(".rangeerrorBalCheck").removeClass("showclass");
							$(".rangeerrorBalCheck").addClass("hideclass");
							$(".disply-partner-cards").removeClass("showclass");
							$(".disply-partner-cards").addClass("hideclass");
							$(".points-exchange-form-display").removeClass("showclass");
							 $(".points-exchange-form-display").addClass("hideclass");
							$( "h2" ).hide();
							$(".points-exchange-form-confirm").removeClass("hideclass");//SHOW
							$(".points-exchange-form-confirm").addClass("showclass");//SHOW
							$(".confirm--button--form--field").removeClass("hideclass");//SHOW
							$(".confirm--button--form--field").addClass("showclass");//SHOW
							$(".confirm--mail--security--check").removeClass("showclass");
							$(".confirm--mail--security--check").addClass("hideclass");
							$(".points-exchange-form-succss--div").removeClass("showclass");
							$(".points-exchange-form-succss--div").addClass("hideclass");
							$(".points-exchange-form-failure--div").removeClass("showclass");
							$(".points-exchange-form-failure--div").addClass("hideclass");
							$(".cardStatusError").removeClass("showclass");
							$(".cardStatusError").addClass("hideclass");
							//alert("after succ"+cardNumberwithSpace);
							//Binfinite
							enrichMilesConfirmPoints.val(enrichMilesInputPoints);
							bInfiniteConfirmPoints.val(bInfiniteInputPoints);
							cardConfirmNumber.val(cardNumberwithSpace);			
							$("#b-infinite-acct-number--confirm").val(cardNumberwithSpace);
							//_self.partnerPointsExcForm.find('#b-infinite-acct-number--confirm').val(cardNumberwithSpace);
						}
						else
						{
							$(".error-validation").removeClass("hideclass");
                   			$(".error-validation").addClass("showclass");
							$(".accounterror").removeClass("showclass");
							$(".accounterror").addClass("hideclass");
							$(".rangeerror").removeClass("showclass");
							$(".rangeerror").addClass("hideclass");
							$(".rangeerrorBalCheck").removeClass("showclass");
							$(".rangeerrorBalCheck").addClass("hideclass");
							$(".cardStatusError").removeClass("hideclass");
							$(".cardStatusError").addClass("showclass");
						}
						defer.resolve(json);			
					}, error: function(error: any) {
						
						_self.bookingformcommon.preloaderClose();
						defer.reject(error);
					}
				});
			}
		});

		$("#partner-card-number").keypress(function (e:any) {
			$("#mob-partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#partner-card-number').val(foo);
			return true;
			}
		});
		$("#partner-card-number").keyup(function (e:any) {
			$("#mob-partner-card-number").val('');
			let foo = $('#partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#partner-card-number').val(foo);
			return true;
		});
		$("#mob-partner-card-number").keypress(function (e:any) {
			$("#partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#mob-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-partner-card-number').val(foo);
			return true;
			}
		});
		$("#mob-partner-card-number").keyup(function (e:any) {
			$("#partner-card-number").val('');
			let foo = $('#mob-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-partner-card-number').val(foo);
			return true;
		});
		$("#sunwaypauls-partner-card-number").keypress(function (e:any) {
			$("#mob-sunwaypauls-partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#sunwaypauls-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#sunwaypauls-partner-card-number').val(foo);
			}
		});
		$("#sunwaypauls-partner-card-number").keyup(function (e:any) {
			$("#mob-sunwaypauls-partner-card-number").val('');
			let foo = $('#sunwaypauls-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#sunwaypauls-partner-card-number').val(foo);
		});
		$("#mob-sunwaypauls-partner-card-number").keypress(function (e:any) {
			$("#sunwaypauls-partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#mob-sunwaypauls-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-sunwaypauls-partner-card-number').val(foo);
			}
		});
		$("#mob-sunwaypauls-partner-card-number").keyup(function (e:any) {
			$("#sunwaypauls-partner-card-number").val('');
			let foo = $('#mob-sunwaypauls-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-sunwaypauls-partner-card-number').val(foo);
		});
		// Bonus Link bonuslink-partner-card-number
		$("#bonuslink-partner-card-number").keypress(function (e:any) {
			$("#mob-bonuslink-partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#bonuslink-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#bonuslink-partner-card-number').val(foo);
			}
		});
		$("#bonuslink-partner-card-number").keyup(function (e:any) {
			$("#mob-bonuslink-partner-card-number").val('');
			let foo = $('#bonuslink-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#bonuslink-partner-card-number').val(foo);
		});
		$("#mob-bonuslink-partner-card-number").keypress(function (e:any) {
			$("#bonuslink-partner-card-number").val('');
			if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
				//display error message
				$(".cardnumberformatErrMsg").show();
					   return false;
			}
			else{
			$(".cardnumberformatErrMsg").remove();
			let foo = $('#mob-bonuslink-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-bonuslink-partner-card-number').val(foo);
			}
		});
		$("#mob-bonuslink-partner-card-number").keyup(function (e:any) {
			$("#bonuslink-partner-card-number").val('');
			let foo = $('#mob-bonuslink-partner-card-number').val().split(" ").join(""); // remove hyphens
  			if (foo.length > 0) {
    			foo = foo.match(new RegExp('.{1,4}', 'g')).join(" ");
  			}
  			$('#mob-bonuslink-partner-card-number').val(foo);
		});


		$('input[type="radio"]').click(function() {
			if($(this).attr('id') == 'points-exc--miles-terms-and-conditions') {
				//$("#termscondiText").removeClass("radioErrMsg");
				$(".radioErrMsg").removeClass("showclass");
				$(".radioErrMsg").addClass("hideclass");
				$(".error-validation").removeClass("showclass");
                $(".error-validation").addClass("hideclass");
			}
			else {
				//$("#termscondiText").addClass("radioErrMsg");
				$(".radioErrMsg").removeClass("hideclass");
				$(".radioErrMsg").addClass("showclass");
				$(".error-validation").removeClass("hideclass");
                $(".error-validation").addClass("showclass");
			}
		});
		
		function parseJwt (token:any): any {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(base64);
		};
	}
	initSubmitConfirmForm(): any {
		let defer = $.Deferred();
		let _self = this;
		let enrichMilesConfirmPoints = _self.partnerPointsExcForm.find('#total-miles-deduct--confirm');
		let bInfiniteConfirmPoints = _self.partnerPointsExcForm.find('#total-binfinite-recieve--confirm');
		let cardConfirmNumber = _self.partnerPointsExcForm.find('#b-infinite-acct-number--confirm');

		$(".btn-points--confirm-admin").click(function() {
			let partner_code  = $(".points-exchange-form-display input:hidden[class='partnerId']").val();

			let enrichMilesInputPoints = _self.partnerPointsExcForm.find('#enrich-miles-field').val();
		    let bInfiniteInputPoints = _self.partnerPointsExcForm.find('#b-infinity-field').val();
			let cardInputNumber_deskT = _self.partnerPointsExcForm.find('#partner-card-number').val();
			let cardInputNumber_mob = _self.partnerPointsExcForm.find('#mob-partner-card-number').val();

			let cardInputNumber:any;
			let enrichMiles:any;
			let inputPoints:any;
			let cardNumberwithSpace:any;
			if(partner_code=='ppgsmt'){
				cardInputNumber="1111 1111 1111 1111"
			}
			else{
				if(cardInputNumber_mob!="")
				{	
					cardInputNumber=cardInputNumber_mob;
				}else 
				{
					cardInputNumber=cardInputNumber_deskT;
				}
			}
			enrichMiles=enrichMilesInputPoints;
			inputPoints=bInfiniteInputPoints;
			cardNumberwithSpace=cardInputNumber;
			//alert("cardNumberwithSpace>>"+cardNumberwithSpace);
			cardInputNumber=cardInputNumber.replace(/ /g,'');

			$(".error-validation").removeClass("showclass");
			$(".error-validation").addClass("hideclass");
			$(".accounterror").removeClass("showclass");
			$(".accounterror").addClass("hideclass");
			$(".rangeerror").removeClass("showclass");
			$(".rangeerror").addClass("hideclass");
			$(".rangeerrorBalCheck").removeClass("showclass");
			$(".rangeerrorBalCheck").addClass("hideclass");
			$(".cardStatusError").removeClass("showclass");
			$(".cardStatusError").addClass("hideclass");
			
			if(enrichMiles=="" || cardInputNumber=="" || inputPoints=="")
			{
				$(".error-validation").removeClass("hideclass");
				$(".error-validation").addClass("showclass");
			}else{
				
				let cookieAccessToken = _self.getCookie("sapphire");
				var decodedToken = parseJwt(cookieAccessToken);
				let partner_code  = $(".points-exchange-form-display input:hidden[class='partnerId']").val();
				let succCode:any;
				var data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid,
					'partner_code': partner_code,
					'action':'generateOTP',
					'channel':'LCP'
				};
				_self.bookingformcommon.preloader();
				$.ajax({
					type: 'POST',
					url: '/bin/services/new/pointExcSubmitDtls',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
							if (typeof data === 'string') {
								json = JSON.parse(data);
							}	else {
								json = data;
							}
						_self.bookingformcommon.preloaderClose();
						succCode=json.succCode;
						
						if (succCode == "OK") {				
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
							$(".mailOTPError").removeClass("showclass");
							$(".mailOTPError").addClass("hideclass");
							enrichMilesConfirmPoints.val(enrichMilesInputPoints);
							bInfiniteConfirmPoints.val(bInfiniteInputPoints);
							cardConfirmNumber.val(cardNumberwithSpace);
							$(".disply-partner-cards").removeClass("showclass");
							$(".disply-partner-cards").addClass("hideclass");
							// $(".points-exchange-form-display").removeClass("showclass");
							// $(".points-exchange-form-display").addClass("hideclass");
							$( "h2" ).hide();
							$(".points-exchange-form-confirm").removeClass("hideclass");//SHOW
							$(".points-exchange-form-confirm").addClass("showclass");//SHOW
							$(".confirm--button--form--field").removeClass("showclass");
							$(".confirm--button--form--field").addClass("hideclass");
							$(".confirm--mail--security--check").removeClass("hideclass");//SHOW
							$(".confirm--mail--security--check").addClass("showclass");//SHOW
							$(".points-exchange-form-succss--div").removeClass("showclass");
							$(".points-exchange-form-succss--div").addClass("hideclass");
							$(".points-exchange-form-failure--div").removeClass("showclass");
							$(".points-exchange-form-failure--div").addClass("hideclass");
						}
						else
						{
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".mailOTPError").removeClass("hideclass");
							$(".mailOTPError").addClass("showclass");
						}
						defer.resolve(json);			
					}, error: function(error: any) {
						
						_self.bookingformcommon.preloaderClose();
						defer.reject(error);
					}
				});
			}
		});
		function parseJwt (token:any): any {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(base64);
		};
	}
	initSubmitSuucssForm(): any {
		let defer = $.Deferred();
		let _self = this;
		$(".btn-points--check--confirm--submit-admin").click(function() {
			let securitycodecheck = _self.partnerPointsExcForm.find('#security-code--check').val();
			$(".error-validation").removeClass("showclass");
			$(".error-validation").addClass("hideclass");
			$(".accounterror").removeClass("showclass");
			$(".accounterror").addClass("hideclass");
			$(".rangeerror").removeClass("showclass");
			$(".rangeerror").addClass("hideclass");
			
			if(securitycodecheck=="")
			{
				$(".error-validation").removeClass("hideclass");
				$(".error-validation").addClass("showclass");
				$(".securityCodeerror").removeClass("hideclass");
				$(".securityCodeerror").addClass("showclass");
			}else{
				$(".btn-points--check--confirm--submit-admin").addClass("disablee");
				let cookieAccessToken = _self.getCookie("sapphire");
				var decodedToken = parseJwt(cookieAccessToken);
				let partner_code  = $(".points-exchange-form-display input:hidden[class='partnerId']").val();
				let validateCode = _self.partnerPointsExcForm.find('#security-code--check').val();
				let succCode:any;
				let partner_id  = $(".points-exchange-form-display input:hidden[class='partnerId']").val();
				let enrichMilesInputPoints = _self.partnerPointsExcForm.find('#enrich-miles-field').val();
		    	let bInfiniteInputPoints = _self.partnerPointsExcForm.find('#b-infinity-field').val();
				let bInfcardConfirmNumber = _self.partnerPointsExcForm.find('#b-infinite-acct-number--confirm').val();
				let sendMemToken = _self.partnerPointsExcForm.find('#memTokenVal').val();
				
				let cardInputNumber:any;
				let enrichMiles:any;
				let inputPoints:any;
				if(partner_code=='ppgsmt'){
					cardInputNumber="1111 1111 1111 1111"
				}
				else{
					cardInputNumber=bInfcardConfirmNumber;
				}
				enrichMiles=enrichMilesInputPoints;
				inputPoints=bInfiniteInputPoints;
				cardInputNumber=cardInputNumber.replace(/ /g,'');
				{
				var data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid,
					'partner_code': partner_code,
					'action':'validateOTP',
					'code':validateCode,
					'enrich_points':enrichMiles,
					'binfinite_points':inputPoints,
					'cardNumber':cardInputNumber,
					'partnerId':partner_id,
					'memberToken':sendMemToken
				};
				_self.bookingformcommon.preloader();
				$.ajax({
					type: 'POST',
					url: '/bin/services/new/pointExcSubmitDtls',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
							if (typeof data === 'string') {
								json = JSON.parse(data);
							}	else {
								json = data;
							}
						_self.bookingformcommon.preloaderClose();
						succCode=json.succCode;
						
						if (succCode == "OK") {
							console.log("sucess");
							//let navMilesEl = _self.$memberHeader.find('.member-nav--miles-info .miles-value');
							let navMilesVal = json.currentBalance;
							$(".miles-value").text(numeral(navMilesVal).format('0,0'));
							document.cookie = "milesCount=" + navMilesVal + ";path=/";
							$(".error-validation").removeClass("showclass");
				$(".error-validation").addClass("hideclass");
				$(".securityCodeerror").removeClass("showclass");
				$(".securityCodeerror").addClass("hideclass");
			$(".disply-partner-cards").removeClass("showclass");
            $(".disply-partner-cards").addClass("hideclass");
            // $(".points-exchange-form-display").removeClass("showclass");
			// $(".points-exchange-form-display").addClass("hideclass");
			$( "h2" ).hide();
			$(".points-exchange-form-confirm").removeClass("showclass");
			$(".points-exchange-form-confirm").addClass("hideclass");
			$(".confirm--button--form--field").removeClass("showclass");
			$(".confirm--button--form--field").addClass("hideclass");
			$(".confirm--mail--security--check").removeClass("showclass");
			$(".confirm--mail--security--check").addClass("hideclass");
			$(".points-exchange-form-succss--div").removeClass("hideclass");
			$(".points-exchange-form-succss--div").addClass("showclass");
			$("#biAcctID").text(json.resp_BI_accountID);
			$("#bi-points").text(json.resp_BI_points);
			$(".points-exchange-form-failure--div").removeClass("showclass");
			$(".points-exchange-form-failure--div").addClass("hideclass");
			$(".securityvalidCodeerror").removeClass("showclass");
			$(".securityvalidCodeerror").addClass("hideclass");
						}else if(succCode=="OTPERROR")
						{
							$(".btn-points--check--confirm--submit-admin").removeClass("disablee");
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".securityvalidCodeerror").removeClass("hideclass");//SHOW
							$(".securityvalidCodeerror").addClass("showclass");//SHOW
							$(".securityCodeerror").removeClass("showclass");
							$(".securityCodeerror").addClass("hideclass");
						}/*else if(succCode=="CRANEGE"){
							
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
							$(".disply-partner-cards").removeClass("showclass");
            				$(".disply-partner-cards").addClass("hideclass");
           	 				$(".points-exchange-form-display").removeClass("showclass");
							$(".points-exchange-form-display").addClass("hideclass");
							$(".points-exchange-form-confirm").removeClass("showclass");
							$(".points-exchange-form-confirm").addClass("hideclass");
							$(".confirm--mail--security--check").removeClass("showclass");
							$(".confirm--mail--security--check").addClass("hideclass");
							$(".securityvalidCodeerror").removeClass("showclass");
							$(".securityvalidCodeerror").addClass("hideclass");
							$(".points-exchange-form-succss--div").removeClass("showclass");
							$(".points-exchange-form-succss--div").addClass("hideclass");
							$(".points-exchange-form-failure--div").removeClass("hideclass");//SHOW
							$(".points-exchange-form-failure--div").addClass("showclass");//SHOW
							$(".crane-err-msg").removeClass("hideclass");//SHOW
							$(".crane-err-msg").addClass("showclass");//SHOW
							$(".general-err-msg").removeClass("showclass");
							$(".general-err-msg").addClass("hideclass");
							$(".bInfinite-err-msg").removeClass("showclass");
							$(".bInfinite-err-msg").addClass("hideclass");
						}else if(succCode=="BIGE"){
							
							$(".error-validation").removeClass("showclass");
							$(".error-validation").addClass("hideclass");
							$(".disply-partner-cards").removeClass("showclass");
            				$(".disply-partner-cards").addClass("hideclass");
           	 				$(".points-exchange-form-display").removeClass("showclass");
							$(".points-exchange-form-display").addClass("hideclass");
							$(".points-exchange-form-confirm").removeClass("showclass");
							$(".points-exchange-form-confirm").addClass("hideclass");
							$(".confirm--mail--security--check").removeClass("showclass");
							$(".confirm--mail--security--check").addClass("hideclass");
							$(".securityvalidCodeerror").removeClass("showclass");
							$(".securityvalidCodeerror").addClass("hideclass");
							$(".points-exchange-form-succss--div").removeClass("showclass");
							$(".points-exchange-form-succss--div").addClass("hideclass");
							$(".points-exchange-form-failure--div").removeClass("hideclass");//SHOW
							$(".points-exchange-form-failure--div").addClass("showclass");//SHOW
							$(".bInfinite-err-msg").removeClass("hideclass");//SHOW
							$(".bInfinite-err-msg").addClass("showclass");//SHOW
							$(".general-err-msg").removeClass("showclass");
							$(".general-err-msg").addClass("hideclass");
							$(".crane-err-msg").removeClass("showclass");
							$(".crane-err-msg").addClass("hideclass");
						}*/
						else{
							
							$(".error-validation").removeClass("hideclass");
							$(".error-validation").addClass("showclass");
							$(".disply-partner-cards").removeClass("showclass");
            				$(".disply-partner-cards").addClass("hideclass");
           	 				// $(".points-exchange-form-display").removeClass("showclass");
							// $(".points-exchange-form-display").addClass("hideclass");
							$(".points-exchange-form-confirm").removeClass("showclass");
							$(".points-exchange-form-confirm").addClass("hideclass");
							$(".confirm--mail--security--check").removeClass("showclass");
							$(".confirm--mail--security--check").addClass("hideclass");
							$(".points-exchange-form-succss--div").removeClass("showclass");
							$(".points-exchange-form-succss--div").addClass("hideclass");
							$(".points-exchange-form-failure--div").removeClass("hideclass");//SHOW
							$(".points-exchange-form-failure--div").addClass("showclass");//SHOW
							$(".general-err-msg").removeClass("hideclass");//SHOW
							$(".general-err-msg").addClass("showclass");//SHOW
							$("#error_code").text(json.err_status_code);
							$("#error_msg").text(json.err_message);
							$(".accounterror").removeClass("showclass");
							$(".accounterror").addClass("hideclass");
							$(".rangeerror").removeClass("showclass");
							$(".rangeerror").addClass("hideclass");
							$(".cardStatusError").removeClass("showclass");
							$(".cardStatusError").addClass("hideclass");
							$(".cardnumberformatErrMsg").removeClass("showclass");
							$(".cardnumberformatErrMsg").addClass("hideclass");
							$(".mailOTPError").removeClass("showclass");
							$(".mailOTPError").addClass("hideclass");
							$(".securityCodeerror").removeClass("showclass");
							$(".securityCodeerror").addClass("hideclass");
							$(".securityvalidCodeerror").removeClass("showclass");
							$(".securityvalidCodeerror").addClass("hideclass");
						}
						defer.resolve(json);			
					}, error: function(error: any) {
						
						_self.bookingformcommon.preloaderClose();
						defer.reject(error);
					}
				});
			}
			}
		});
		$(".btn-points--check--req-again-admin").click(function() {
			$(".btn-points--check--req-again-admin").addClass("disablee");
			_self.partnerPointsExcForm.find('#security-code--check').val("");
			$(".btn-points--check--confirm--submit-admin").removeClass("disablee");
			$(".error-validation").removeClass("showclass");
			$(".error-validation").addClass("hideclass");
			$(".securityCodeerror").removeClass("showclass");
			$(".securityCodeerror").addClass("hideclass");
			$(".securityvalidCodeerror").removeClass("showclass");
			$(".securityvalidCodeerror").addClass("hideclass");
			let cookieAccessToken = _self.getCookie("sapphire");
				var decodedToken = parseJwt(cookieAccessToken);
				let cap_count  = $(".partner-crad-exchange.active input:hidden[class='cap_period_class']").val();
				let partner_code  = $(".points-exchange-form-display input:hidden[class='partnerId']").val();
				let succCode:any;
				var data = {
					'loyaltyToken':	decodedToken.extension_loyaltyToken,
					'enrichId': decodedToken.extension_flyerid,
					'partner_code': partner_code,
					'action':'generateOTP',
					'channel':'LCP'
				};
				_self.bookingformcommon.preloader();
				$.ajax({
					type: 'POST',
					url: '/bin/services/new/pointExcSubmitDtls',
					data: data,
					success: function(data:any){
						//var json = JSON.parse(data);
						let json:any = null;
							if (typeof data === 'string') {
								json = JSON.parse(data);
							}	else {
								json = data;
							}
						_self.bookingformcommon.preloaderClose();
						succCode=json.succCode;
						if (succCode == "OK") {	
							$(".btn-points--check--confirm--submit-admin").removeClass("disablee");
						}
						else
						{
							
						}
						defer.resolve(json);			
					}, error: function(error: any) {
						
						_self.bookingformcommon.preloaderClose();
						defer.reject(error);
					}
				});
			let timeleft = 60;
			let downloadTimer = setInterval(function(){
			$("#timerdisp").removeClass("hideclass");
			$("#timerdisp").addClass("showclass");
			let seconds = _self.checkTime(timeleft);
			  document.getElementById("timerdisp").innerHTML = " ("+seconds+")";
			  //$(".btn-points--check--req-again").append(seconds);
  			timeleft -= 1;
  			if(timeleft<= 0){
				clearInterval(downloadTimer);
				$("#timerdisp").removeClass("showclass");
				$("#timerdisp").addClass("hideclass");
				$("#timerdisp").empty();
				   $(".btn-points--check--req-again-admin").removeClass("disablee");
				   $(".btn-points--check--req-again-admin").remove(seconds);
  			}
		   }, 1000);
		});
		function parseJwt (token:any): any {
			var base64Url = token.split('.')[1];
			var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));
		
			return JSON.parse(base64);
		};
	}
	checkTime(i:any)
	{
		if (i < 10) {
			i = "0" + i;
		  }
		  return i;
	}
	
	rangeslider(): any {
		// Select all range inputs, watch for change
		$("input[type='range']").change(function() {
			var el, newPoint, newPlace, offset;
			// Cache this for efficiency
			el = $(this);
			
			// Measure width of range input
			var width = el.width();
			
			// Figure out placement percentage between left and right of input
			newPoint = (el.val() - el.attr("min")) / (el.attr("max") - el.attr("min"));
			
			offset = -1;
		
			// Prevent bubble from going beyond left or right (unsupported browsers)
			if (newPoint < 0) { newPlace = 0; }
			else if (newPoint > 1) { newPlace = width; }
			else { newPlace = width * newPoint + offset; offset -= newPoint; }
			
			// Move bubble
			el
			.next("output")
			.css({
				left: newPlace,
				marginLeft: offset + "%"
			})
			//  .text(el.val());
			})
			// Fake a change to position bubble at page load
			$("input[type='range']").trigger('change');
	}
	termsandConditionsPanel() {
		$('#points-exchange-admin-form .btn-terms-conditions').click(function(){
			$('#points-exchange-admin-form #binfinte_partner_details').collapse('hide');
		});
		$('#points-exchange-admin-form .btn-partner-details').click(function(){
			$('#points-exchange-admin-form #binfinte_terms').collapse('hide');
		});
		$('#points-exchange-admin-form .sunway-btn-terms-conditions').click(function(){
			$('#points-exchange-admin-form #sunway_partner_details').collapse('hide');
		});
		$('#points-exchange-admin-form .sunway-btn-partner-details').click(function(){
			$('#points-exchange-admin-form #sunway_terms').collapse('hide');
		});
	}
	parseJwt (token:any) {
		var base64Url = token.split('.')[1];
		var base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
			return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
		}).join(''));
	
		return JSON.parse(base64);
	}
	redirectToCardSelectionScreen(_self: any): any {
		window.location.href = location.hostname + 'my/en/enrich-portal/home/redemption/catalogue-lcp.html';
		_self.bookingformcommon.preloaderClose();
	}
	processGrab(_self: any): any {
		_self.bookingformcommon.preloader();
		try {
			GrabID.handleAuthorizationCodeFlowResponse();
			_self.grabIdClient.makeTokenRequest()
			.then(() => {
				let tokenResult = GrabID.getResult();
				if(tokenResult.accessToken != 'undefined' && tokenResult.accessToken != undefined && tokenResult.accessToken != null) {
					let decodedToken = _self.parseJwt(tokenResult.accessToken);
					$('#hidden_grab_partner_uuid').val(decodedToken.sub);
				} else {
					_self.redirectToCardSelectionScreen(_self);
				}
			});
		} catch(e) {
			let error = JSON.parse(e.message);
			console.log(error);
			_self.redirectToCardSelectionScreen(_self);
		}
	}
	checkForUrlParams(): any {
		let _self = this;   
		let urlParams = new URLSearchParams(window.location.search);
		let state = urlParams.get('memberToken');
		_self.memberToken = state;
		if(window.location.search != '' && state !== null && _self.memberToken !== null) {
			return true;
		}
		return false;
	}
	initGrabAuthentication(): any {
		let _self = this;
		let openIdUrl = GrabID.GrabPartnerUrls.STAGING;
		if (window.location.hostname !== 'localhost' && window.location.hostname.indexOf('uat') == -1) {
			openIdUrl = GrabID.GrabPartnerUrls.PRODUCTION;
		}
		let grabClientId = $(".partner-crad-exchange input:hidden[class='grab_client_id_class']").val();
		let requestUri = $(".partner-crad-exchange input:hidden[class='grab_request_uri_class']").val();
		let appConfig = {
			clientId: grabClientId,
			redirectUri: requestUri,
			scope: 'rewards.events_api',
			acrValues: {
				service: 'PASSENGER',
				consentContext: {
					countryCode: 'MY'
				}
			}
		}
		this.grabIdClient = new GrabID(openIdUrl, appConfig);
	}
	initDenominations():any{
		let _self = this;
			let dynamicListHtml = '';
			
			for(var i = 0; i < _self.voucherList.length; i++){
				if((_self.voucherList[i].promoAvail) != "N"){
					dynamicListHtml+=`<li class="">${_self.voucherList[i].exchangepoints}<span class="promo-align">promo</span></li>`;
				}else{
					dynamicListHtml+=`<li class="">${_self.voucherList[i].exchangepoints}</li>`;
				}
		}	
			
			let finalHtml = `<div class="col-xs-12 col-sm-6" id="mhgiftcard-denomination">
			  <ul class="voucher-denominations">`
				+ dynamicListHtml +
			  `</ul>
			</div>`;
		  let elm = $('#points-exchange-form-step2').find('div.row.pointExchangeDenomination');
		  elm.html(finalHtml);

		  _self.handleDenominationChange();		
		_self.handleTermsConditions();
	}

	handleDenominationChange(): any {
		let _self = this;
		let denominationsActive = $('#points-exchange-form-step2 .voucher-denominations li');
		$('#points-exchange-form-step2 .voucher-denominations li:first').addClass('active');
		$('#enrich-miles-field').val(_self.selectedVoucher.enrichPoints);
		$('#b-infinity-field').val(_self.selectedVoucher.exchangepoints);
		$('#points-exchange-form-step2 .voucher-denominations li').click(function () {
			$('.voucher-denominations li').removeClass('active');
			$(this).addClass('active');
			_self.selectedDenomination = $(this).clone().children().remove().end().text();
			_self.selectedVoucher = _self.voucherList.find((item: any) => item.exchangepoints == _self.selectedDenomination);
			$('#enrich-miles-field').val(_self.selectedVoucher.enrichPoints);
			$('#b-infinity-field').val(_self.selectedVoucher.exchangepoints);
			
		});
	

	}
	
	
	handleTermsConditions():any{
		let _self=this;
				
			$(document).on('click',function(){
				if((_self.mymilesPointExchange.find('#enrich-miles-field').val()) && ($('#points-exc--miles-terms-and-conditions').is(':checked'))){
					$(".btn-member--submit").removeClass("disabled");
					$(".btn-member--submit").addClass('submit-btn-color');
					$('.btn-member--submit').removeClass('btn-primary-color');
				}else{
					$(".btn-member--submit").addClass("disabled");
					$(".btn-member--submit").removeClass('submit-btn-color');
					$('.btn-member--submit').addClass('btn-primary-color');	
				}
			});
			
		
	}
}
let scope:Element = document.querySelector('#points-exchange-admin-form');

if (scope) {
	try {
	let membergrv = new memberPointsExchange();	
	membergrv.initSelectCard();
	membergrv.rangeslider();
	membergrv.initSubmitNextForm();
	membergrv.initSubmitConfirmForm();
	membergrv.initSubmitSuucssForm();
	membergrv.termsandConditionsPanel();
	//membergrv.handleTermsConditions();
	//membergrv.initVouchersAndUsers();
	//membergrv.initDenominations();
	} catch(e) {console.error(e);}
}